import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import Home from './components/Home.vue'
import Login from "./components/Login.vue"
import Cuenta from "./components/Cuenta.vue"
import Calendar from "./components/Calendar.vue"
import CalendarDr from "./components/CalendarDr.vue"
import SignUp from "./components/SignUp.vue"
import Profesional from "./components/Profesional.vue"
import Forgot from "./components/Forgot.vue"
import Resend from "./components/Resend.vue"
import Turno from "./components/Turno.vue"
import Help from "./components/Help.vue"
import CitasPaciente from "./components/CitasPaciente.vue"
import CitasSimple from "./components/CitasSimple.vue"
import CitasPublico from "./components/CitasPublico.vue"
import WorkCalendar from "./components/WorkCalendar.vue"
import WorkCalendarDelete from "./components/WorkCalendarDelete.vue"
import SignUpSuccess from "./components/SignUpSuccess.vue"
import PacienteList from "./components/PacienteList.vue"
import HistoriaClinica from "./components/HistoriaClinica.vue"
import AuthTest from "./components/AuthTest.vue"
import About from "./components/About.vue"
import CompletarPerfil from "./components/CompletarPerfil.vue"
import MisEstudios from "./components/MisEstudios.vue"
import ProfesionalABM from "./components/ProfesionalABM.vue"

Vue.use(VueRouter)

const routes = [
  // ========== RUTAS PÚBLICAS ==========
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUp,
    meta: { public: true }
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: Forgot,
    meta: { public: true }
  },
  {
    path: '/resend',
    name: 'resend',
    component: Resend,
    meta: { public: true }
  },
  {
    path: '/signupsuccess',
    name: 'signupsuccess',
    component: SignUpSuccess,
    meta: { public: true }
  },
  {
    path: '/nuevoturno',
    name: 'nuevoturno',
    component: CitasPublico,
    meta: { public: true }
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
    meta: { public: true }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { public: true }
  },

  // ========== RUTAS PROTEGIDAS (requieren login) ==========
  {
    path: '/turnos',
    name: 'calendar',
    component: Calendar,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      // Redirigir según el rol del usuario
      const userProfile = store.state.user_profile;
      
      if (userProfile) {
        // Intentar obtener el rol de diferentes posibles ubicaciones
        let role = userProfile.role || 
                   (userProfile.roles && userProfile.roles[0]) ||
                   null;
        
        if (role) {
          role = role.toLowerCase();
          
          // Médicos van a /agenda
          if (role === 'doctor' || role === 'medico' || role === 'health_professional') {
            return next('/agenda');
          } 
          // Secretarias y admin van a /turnos-secretaria
          else if (role === 'secretary' || role === 'secretaria' || role === 'admin') {
            return next('/turnos-secretaria');
          }
        }
      }
      
      // Pacientes o sin rol definido pueden ver Calendar
      next();
    }
  },
  {
    path: '/calendar',
    redirect: '/turnos'
  },
  {
    path: '/historia-clinica',
    name: 'historia-clinica',
    component: HistoriaClinica,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'doctor', 'medico', 'health_professional', 'admin'] }
  },
  {
    path: '/mi-historia-clinica',
    name: 'mi-historia-clinica',
    component: HistoriaClinica,
    meta: { requiresAuth: true, roles: ['patient', 'paciente'] }
  },
  {
    path: '/mis-estudios',
    name: 'mis-estudios',
    component: MisEstudios,
    meta: { requiresAuth: true }
  },
  {
    path: '/agenda',
    name: 'calendardr',
    component: CalendarDr,
    meta: { requiresAuth: true, roles: ['doctor', 'medico', 'health_professional', 'admin'] }
  },
  {
    path: '/editaccount',
    name: 'cuenta',
    component: Cuenta,
    meta: { requiresAuth: true }
  },
  {
    path: '/turno',
    name: 'turno',
    component: Turno,
    meta: { requiresAuth: true }
  },
  {
    path: '/events',
    name: 'citasdr',
    component: CitasSimple,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'admin', 'doctor', 'medico', 'health_professional'] }
  },
  {
    path: '/turnospaciente',
    name: 'citaspaciente',
    component: CitasPaciente,
    meta: { requiresAuth: true }
  },
  {
    path: '/pacienteList',
    name: 'paciente',
    component: PacienteList,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'doctor', 'medico', 'health_professional', 'admin'] }
  },
  {
    path: '/turnos-secretaria',
    name: 'citasecretaria',
    component: CitasSimple,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'admin'] }
  },
  {
    path: '/citas-simple',
    name: 'citassimple',
    component: CitasSimple,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'admin'] }
  },
  {
    path: '/workcalendar',
    name: 'workcalendar',
    component: WorkCalendar,
    meta: { requiresAuth: true, roles: ['doctor', 'medico', 'health_professional', 'admin'] }
  },
  {
    path: '/profesional',
    name: 'profesional',
    component: ProfesionalABM,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'admin'] }
  },
  {
    path: '/profesionales-abm',
    name: 'profesionales-abm',
    component: ProfesionalABM,
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'admin'] }
  },
  {
    path: '/calendardelete',
    name: 'workcalendardelete',
    component: WorkCalendarDelete,
    meta: { requiresAuth: true, roles: ['doctor', 'medico', 'health_professional', 'admin'] }
  },
  {
    path: '/completar-perfil',
    name: 'completar-perfil',
    component: CompletarPerfil,
    meta: { requiresAuth: true }
  },
  {
    path: '/paciente/:idPaciente',
    component: () => import('./components/PacienteDetalle.vue'),
    name: 'paciente-detalle',
    meta: { requiresAuth: true, roles: ['secretary', 'secretaria', 'doctor', 'medico', 'health_professional', 'admin'] }
  },

  // ========== RUTAS DE DESARROLLO/TEST (solo en dev) ==========
  {
    path: '/auth-test',
    name: 'auth-test',
    component: AuthTest,
    meta: { public: true } // Solo para testing
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Helper para obtener el rol normalizado del usuario
function getUserRole(storeInstance) {
  // Superusuario sin perfil elegido: arranca en la vista de secretaría
  if (storeInstance.getters.isSuperuser && !storeInstance.state.view_as) {
    return 'secretary';
  }
  const userProfile = storeInstance.state.user_profile;
  let role = null;

  if (userProfile) {
    if (typeof userProfile.role === 'string' && userProfile.role) {
      role = userProfile.role;
    } else if (Array.isArray(userProfile.roles) && userProfile.roles.length > 0) {
      role = userProfile.roles[0];
    }
  }

  if (!role && storeInstance.state.credentials && storeInstance.state.credentials.role) {
    role = storeInstance.state.credentials.role;
  }

  return role ? role.toLowerCase() : null;
}

// Helper para verificar si un rol coincide con los roles permitidos por equivalencia
function isRoleAllowed(role, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  if (!role) return false;

  const r = role.toLowerCase();
  const allowed = allowedRoles.map(a => a.toLowerCase());

  if (allowed.includes(r)) return true;

  const isSec = r === 'secretary' || r === 'secretaria' || r === 'admin';
  const isDoc = r === 'doctor' || r === 'medico' || r === 'health_professional';

  if (isSec && (allowed.includes('secretary') || allowed.includes('secretaria') || allowed.includes('admin'))) {
    return true;
  }
  if (isDoc && (allowed.includes('doctor') || allowed.includes('medico') || allowed.includes('health_professional') || allowed.includes('admin'))) {
    return true;
  }

  return false;
}

// Guard global de navegación para redireccionar según rol
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.authenticated;
  const role = getUserRole(store);

  const isSecretary = role === 'secretary' || role === 'secretaria' || role === 'admin';
  const isDoctor = role === 'doctor' || role === 'medico' || role === 'health_professional';

  if (isAuthenticated) {
    // Viendo como otro usuario (solo lectura) no se edita la cuenta ni el perfil
    if (store.getters.viewAsEmail && ['/editaccount', '/completar-perfil'].includes(to.path)) {
      const home = isDoctor ? '/agenda' : '/turnos';
      return next(from.name ? false : home);
    }

    // Si ya está autenticado e intenta ir a /login, redirigir a su home
    if (to.path === '/login') {
      const target = isSecretary ? '/turnos-secretaria' : (isDoctor ? '/agenda' : '/turnos');
      if (to.path !== target) return next(target);
      return next();
    }

    // Secretarias no deben ver URLs de turnos de paciente ni la home pública (/)
    if (isSecretary) {
      const patientRoutes = ['/', '/turnos', '/calendar', '/turnospaciente', '/nuevoturno'];
      if (patientRoutes.includes(to.path)) {
        if (to.path !== '/turnos-secretaria') {
          return next('/turnos-secretaria');
        }
        return next();
      }
    }

    // Médicos no deben ver / ni turnos de paciente
    if (isDoctor) {
      const patientRoutes = ['/', '/turnos', '/calendar', '/turnospaciente', '/nuevoturno'];
      if (patientRoutes.includes(to.path)) {
        if (to.path !== '/agenda') {
          return next('/agenda');
        }
        return next();
      }
    }

    // Control de acceso por meta.roles en rutas protegidas
    if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
      const requiredRoles = to.matched.reduce((acc, record) => {
        if (record.meta && record.meta.roles) {
          return acc.concat(record.meta.roles);
        }
        return acc;
      }, []);

      if (requiredRoles.length > 0) {
        if (!isRoleAllowed(role, requiredRoles)) {
          const target = isSecretary ? '/turnos-secretaria' : (isDoctor ? '/agenda' : '/turnos');
          if (to.path !== target) {
            return next(target);
          }
          return next();
        }
      }
    }
  } else {
    // Si no está autenticado y la ruta requiere auth, redirigir a /login
    if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
      if (to.path !== '/login') {
        return next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      }
      return next();
    }
  }

  next();
});

export default router

